import React from 'react';
import PropTypes from 'prop-types';

const NavigationLevel = ({active, level}) => (
    <div style={{
        ...styles.container,
        color: active ? '#e41b60' : '#969696'
    }}>{`Level ${level}`}</div>
);

NavigationLevel.propTypes = {
    active: PropTypes.bool.isRequired,
    level: PropTypes.number.isRequired,
};

const styles = {
    container: {
        color: '#969696',
        paddingRight: '5px',
        fontFamily: 'Ubuntu',
        fontSize: '13pt'
    }
}

export default NavigationLevel;
